import { useMutation, useQuery } from '@tanstack/react-query';

import { generateQuestions } from '../../../api/ai';

export function useGenerateQuestions() {
  return useMutation({ mutationFn: generateQuestions });
}
